import { WellnessScoreStatus } from "../../../Common/types";

export function getExerciseStatus(minutesPerWeek: number): WellnessScoreStatus {
  if (minutesPerWeek >= 300) return WellnessScoreStatus.Healthy;
  if (minutesPerWeek >= 150) return WellnessScoreStatus.NeedsAttention;
  return WellnessScoreStatus.NeedsSupport;
}

export function getExerciseDisplayValue(minutesPerWeek: number): string {
  if (minutesPerWeek >= 300) return ">300";
  if (minutesPerWeek >= 150) return ">150";
  return "<150";
}
